/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 890, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}

function header_branding_box(){
  var siteheader = document.querySelector('.site-header');
  var box = document.querySelector('.site-header__branding');
  if(siteheader.classList.contains('scrolled')){
    return false;
  }
  var magicnumber = 0;
  var real_offset = box.offsetTop - siteheader.offsetTop + magicnumber;
  box.style = "transform: translateY(-" + (+real_offset) + "px);";
}
header_branding_box();

var header_original_size = null;
function header_resizer(){
  var scroll = jQuery(window).scrollTop();
  if (header_original_size == null){
    header_original_size = document.querySelector('.site-header').clientHeight;
  }

  if (scroll >= 300) {
      jQuery(".site-header").addClass("scrolled");
      if(!jQuery('#site-header__spacer').length){
        jQuery(".site-header").before('<div id="site-header__spacer" style="height: '+header_original_size+'px;"></div>');
      }
    } else {
      jQuery(".site-header").removeClass("scrolled");
      jQuery("#site-header__spacer").remove();
      header_branding_box();
      header_original_size = null;
      // header_branding_box();
  }
}

(function($){

  jQuery(window).resize(function() {
    header_branding_box();
  });

  $(document).ready(function(){


    header_resizer();

    // header_branding_box();

    $(window).scroll(function() {
      header_resizer();
    });

    if ($('.blocks-gallery-item a').length > 0){
      var lightbox = $('.blocks-gallery-item a').simpleLightbox();
    }

  });
})(jQuery);
